import { useState } from 'react';
import { useHistory } from 'react-router';

import { Box, MenuItem, useTheme } from '@mui/material';
import { StyledMenu } from '../styles';
import { TextButton } from 'sharedComponents/Buttons';
import auth from 'utils/auth';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export const UserDropdownMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const user = auth.getUser();
  const history = useHistory();
  const theme = useTheme();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  const handleReleaseHijack = () => {
    auth.handleReleaseHijack();
    setAnchorEl(null);
  };

  const handleLogOut = () => auth.logout().then(() => history.push('/login'));

  return (
    <>
      <Box>
        <TextButton
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          sx={{ fontSize: theme.typography.body2.fontSize }}
        >
          {user?.name} <KeyboardArrowDownIcon />
        </TextButton>
      </Box>
      <StyledMenu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {user.is_hijacked && <MenuItem onClick={handleReleaseHijack}>Release hijack</MenuItem>}
        <MenuItem onClick={handleLogOut}>Log Out</MenuItem>
      </StyledMenu>
    </>
  );
};
